module.exports = __webpack_public_path__ + "img/la.1ba0a5f5.svg";